import { IGoogleConfig } from '../../types/google-interfaces';
import { addLoginQueryParams } from '../../utils/url';
import { appendUnityLoginIframe } from '../../utils/landing';

interface IdGoogleToken {
    credential?: string,
}

export class GoogleOneTap {
    private config: IGoogleConfig;
    private accessToken: string;

    constructor(config: IGoogleConfig) {
        this.config = config;
    }

    public init(): void {
        window.onload = () => {
            window.google.accounts.id.initialize({
                client_id: this.config.client_id,
                prompt_parent_id: 'google-one-tap__container',
                callback: this.handleCredentials.bind(this)
            });
            window.google.accounts.id.prompt();
        };
    }

    public getToken(): string {
        return this.accessToken ? undefined : this.accessToken;
    }

    private handleCredentials(credentials: IdGoogleToken) {
        if (!credentials.credential) {
            throw new Error('ID Token is not exist for user');
        }

        const oauthBaseUrl = window.app.config.google.oauth_one_tap_url;
        const oAuthLink = `${oauthBaseUrl}?idtoken=${credentials.credential}`;
        const queriedOAuthLink = addLoginQueryParams(oAuthLink);

        appendUnityLoginIframe(queriedOAuthLink);
    }
}
